<template>
  <div class="bonus-input">
    <label class="bonus-input__label">
      <input
        ref="inputBonus"
        class="bonus-input__field"
        v-model="inputValue.amount"
        aria-label="Поле ввода бонусов"
        inputmode="numeric"
        type="number"
        v-bind:disabled="disabled"
        v-on:input="onInput"
      />
    </label>
    <p
      v-for="error in violations"
      v-bind:key="error"
      class="bonus-input__violation"
      role="alert"
    >
      {{ error }}
    </p>
  </div>
</template>
<script>
import { Bonuses } from '@/mixins/loyaltySystemMixin';

/**
 * @description Поле ввода стоимости в рублях.
 */
export default {
  data() {
    return {
      /**
       * @description Значение поля ввода.
       * @type {Bonuses}
       */
      inputValue: this.value,
    };
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event
     * @returns {void}
     */
    onInput(event) {
      const { value } = event.target;
      if (value === '') {
        this.$emit('input', this.clamp(0));
        return;
      }
      this.$emit('input', this.clamp(+value));
    },
    /**
     * @description Ограничить значение диапазоном от min до max включительно.
     * @param {number} initialValue
     * @returns {number}
     */
    clamp(initialValue) {
      let value = initialValue;
      if (this.max !== undefined) {
        value = Math.min(value, this.max);
      }
      if (this.min !== undefined) {
        value = Math.max(value, this.min);
      }
      this.inputValue = new Bonuses(value);
      return this.inputValue;
    },
  },
  props: {
    mask: {
      default: '######',
      type: String,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    max: {
      default: () => undefined,
      type: Number,
    },
    min: {
      default: () => undefined,
      type: Number,
    },
    value: {
      required: true,
      type: Bonuses,
    },
    violations: {
      default: () => [],
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.bonus-input {
  display: inline-flex;
  width: min(100%, 152px);
  min-width: 100px;
  &__label {
    position: relative;
    &::after {
      content: 'Б';
      position: absolute;
      top: 50%;
      right: 15px;
      color: #90A0B7;
      transform: translateY(-50%);
    }
  }
  &__field {
    width: 100%;
    height: 40px;
    padding: 10px;
    padding-right: 32px;
    font-size: 16px;
    border-radius: var(--input-border-radius);
    border: 1px solid var(--border-color);
    &:focus-visible {
      outline-color: var(--action-color);
    }
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: 0.125rem;
  }
}

input[type='number'] {
  -moz-appearance: textfield;
}

</style>
